
import {
  computed,
  defineComponent
} from 'vue'
import resize from '@/layout/resize'
import { DeviceType } from '@/store/modules/app/state'

export default defineComponent({
  name: 'Pagination',

  props: {
    currentPage: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array as () => number[],
      default: () => [10, 20, 50, 100, 200]
    },
    // 小于这个宽度时使用 small 模式
    smallWidth: {
      type: Number,
      default: 768
    }
  },

  emits: ['size-change', 'current-change'],

  setup(props, { emit }) {
    const { device } = resize()
    const isMobileDevices = computed(() => {
      return device.value === DeviceType.Mobile
    })
    const handleSizeChange = (size: number) => {
      emit('size-change', size)
    }

    const handleCurrentChange = (page: number) => {
      emit('current-change', page)
    }

    return {
      isMobileDevices,
      handleSizeChange,
      handleCurrentChange
    }
  }
})
